import i18n from 'i18next';
import { createSlice } from '@reduxjs/toolkit';
import { toast } from '@oliasoft-open-source/react-ui-library';

import { apiCallBegan } from 'client/store/middleware/api/api';
import translations from 'client/internationalization/translation-map.json';
import { IFeatureFlagState, IFeaturFlagPayload } from 'common/interfaces/feature-flag.interfaces';

const initialState: IFeatureFlagState = {
  isFetching: true,
  isAdding: false,
};

const featureFlag = createSlice({
  name: 'featureFlag',
  initialState,
  reducers: {
    featureFlagSaveRequested: (featureFlag) => {
      featureFlag.isAdding = true;
    },
    featureFlagSaved: (featureFlag) => {
      featureFlag.isAdding = false;
    },
    featureFlagSaveFailed: (featureFlag) => {
      featureFlag.isAdding = false;
    },
    featureFlagsInitialized: (state) => {
      state.isFetching = false;
    },
  },
});

export const {
  featureFlagSaveRequested,
  featureFlagSaved,
  featureFlagSaveFailed,
  featureFlagsInitialized,

} = featureFlag.actions;
export default featureFlag.reducer;

export const updateFeatureFlag = (data: IFeaturFlagPayload) => {
  return apiCallBegan({
    url: '/feature-flags',
    method: 'PATCH',
    data,
    onStart: featureFlagSaveRequested.type,
    onSuccess: (response: any) => {
      toast({
        message: {
          type: 'Success',
          content: i18n.t(
            translations.featureFlag_successfullySaved,
          ) as string,
        },
      });
      return {
        type: featureFlagSaved.type,
        payload: response,
      };
    },
    onError: () => {
      toast({
        message: {
          type: 'Error',
          content: i18n.t(
            translations.featureFlag_failedToSave,
          ) as string,
        },
      });
      return {
        type: featureFlagSaveFailed.type,
      };
    },
  });
};
